export const calculateOrientation = (dimensions?: {
  width?: number;
  height?: number;
}): 'landscape' | 'portrait' =>
  (dimensions?.width && dimensions.height
    ? dimensions?.width / dimensions?.height
    : 1) < 1
    ? 'portrait'
    : 'landscape';
